import axios from "axios";

import type { Application, UserApplication } from "@virtual-brain-lib/types";

import env from "../environments";

export const deleteUserApplication = async (userApplicationId: string) => {
	await axios.delete(`${env.apiUrl}/users-applications/${userApplicationId}`);
};

export const createUserApplication = async (
	userId: string,
	applicationId: string,
	readOnly: boolean,
) => {
	const response = await axios.post<UserApplication>(`${env.apiUrl}/users-applications`, {
		userId,
		applicationId,
		readOnly,
	});

	return response.data;
};

export const updateUserApplication = async (userApplicationId: string, readOnly: boolean) => {
	await axios.put(`${env.apiUrl}/users-applications/${userApplicationId}`, {
		readOnly,
	});
};

export const transferAppOwnership = async ({
	appId,
	newOwnerId,
}: {
	appId: string;
	newOwnerId: string;
}) => {
	const response = await axios.post<Application>(
		`${env.apiUrl}/applications/${appId}/transfer-ownership`,
		{
			newOwnerId,
		},
	);

	return response.data;
};
